export abstract class LocalStorage {
  abstract put<T = unknown>(key: string, value: T): Promise<T>;
  abstract get<T = unknown>(key: string): Promise<T | undefined>;
  abstract delete(key: string): Promise<void>;
  abstract clear(): Promise<void>;
}
